import { render, staticRenderFns } from "./SuiteTemplateDatabaseApp.vue?vue&type=template&id=259f43c6&"
import script from "./SuiteTemplateDatabaseApp.vue?vue&type=script&lang=js&"
export * from "./SuiteTemplateDatabaseApp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports